import { useSearchParams } from 'react-router-dom';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@vnetwork/ui/primitives';
import { PhysicalInventoryTab } from './physical-inventory-tab';
import { CloudResourcesTab } from './cloud-resources-tab';

const TABS = [
  { value: 'physical', label: 'Physical Inventory' },
  { value: 'cloud', label: 'Cloud Resources' },
] as const;

const TAB_VALUES = TABS.map((t) => t.value) as readonly string[];

/**
 * Capacities & Resources landing dashboard — a 1-1 rebuild of the legacy
 * Warehouse dashboard. Two tabs: Physical Inventory (warehouse stats) and
 * Cloud Resources (ServiceMgmt compute/storage). Tab persisted in `?tab=`.
 * Read-only.
 */
export default function CapacitiesDashboardPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get('tab');
  const activeTab = requested && TAB_VALUES.includes(requested) ? requested : 'physical';

  const onTabChange = (value: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', value);
    setSearchParams(next, { replace: true });
  };

  return (
    <Container size="full">
      <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
        <PageHeader
          title="Capacities & Resources"
          description="Physical inventory and cloud resource capacity overview"
        />

        <Tabs value={activeTab} onValueChange={onTabChange}>
          <TabsList>
            {TABS.map((tab) => (
              <TabsTrigger key={tab.value} value={tab.value}>
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>

          <TabsContent value="physical">
            {activeTab === 'physical' ? <PhysicalInventoryTab /> : null}
          </TabsContent>
          <TabsContent value="cloud">
            {activeTab === 'cloud' ? <CloudResourcesTab /> : null}
          </TabsContent>
        </Tabs>
      </div>
    </Container>
  );
}
